import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';

export const BasicAvatar = ({ thumbnail, title, href }) => (
	<Avatar className='flex-start'>
		<AvatarImage size='sm' src={thumbnail} alt={title} />
		<AvatarContent>
			<AvatarDescription>{title}</AvatarDescription>
		</AvatarContent>
	</Avatar>
);
